import { useEffect } from "react";
import { Button } from "ui/button";
import { CalendarCheck, Ban, Plus } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import Availability from "./Availability/Availability";
import BlockProperty from "./BlockProperty/BlockProperty";
import { useScreenPermission } from "hooks/useScreenPermission";
import { usePageHeader } from "contexts/PageHeaderContext";

export const PropertyAvailabilityMasterPage = () => {
  const { setPageHeader } = usePageHeader();
  const { screenName, icon: ScreenIcon } = useScreenPermission();
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = location.pathname.includes("/block")
    ? "block-property"
    : "availability";

  useEffect(() => { 
      setPageHeader({
        title: screenName,
        icon: <ScreenIcon className="h-6 w-6" />,
      });
  
      return () => setPageHeader(null);
    }, [screenName, ScreenIcon, setPageHeader]);

  return (
    <div className="space-y-6 pb-8">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
        
        {/* Route Based Tab Buttons */}
        <div className="inline-flex items-center bg-[#EEF4FA] rounded-xl p-1 w-fit">
          {/* Availability */}
          <button
            onClick={() => navigate("/property-availability")}
            className={`flex items-center justify-center gap-2 min-w-[170px] px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
              activeTab === "availability"
                ? "bg-[#5B9BD5] text-white shadow-sm"
                : "text-[#1E3A5F] hover:bg-white/50"
            }`}
          >
            <CalendarCheck className="w-4 h-4" />
            Availability
          </button>

          {/* Block Property */}
          <button
            onClick={() => navigate("/property-availability/block")}
            className={`flex items-center justify-center gap-2 min-w-[170px] px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
              activeTab === "block-property"
                ? "bg-[#5B9BD5] text-white shadow-sm"
                : "text-[#1E3A5F] hover:bg-white/50"
            }`}
          >
            <Ban className="w-4 h-4" />
            Block Property
          </button>
        </div>

        {/* Header Action Buttons */}
        <div className="flex items-center gap-3 self-end lg:self-start">
          {activeTab === "availability" && (
            <>
              <Button
                onClick={() => navigate("/property-availability/add")}
                style={{ background: "#5B9BD5" }}
                className="text-white"
              >
                <Plus className="w-4 h-4 mr-2" />
                Add Availability
              </Button>
            </>
          )}

          {activeTab === "block-property" && (
            <Button
              onClick={() => navigate("/property-availability/block/add")}
              style={{ background: "#5B9BD5" }}
              className="text-white"
            >
              <Ban className="w-4 h-4 mr-2" />
              Add Block
            </Button>
          )}
        </div>
      </div>


      {/* Content */}
      <div style={{ marginTop: "10px" }}>
        {activeTab === "availability" ? <Availability /> : <BlockProperty />}
      </div>
    </div>
  );
};

export default PropertyAvailabilityMasterPage;
